import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "../lib/tracking";

/** Dedupe Strict Mode double-invocation and identical consecutive locations (see `location.key`). */
let lastPageSignature: string | null = null;

/**
 * Sends a GA4 `page_view` when the SPA route changes. Lives inside the router tree.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const signature = `${location.key}|${location.pathname}|${location.search}|${location.hash}`;
    if (lastPageSignature === signature) return;
    lastPageSignature = signature;
    trackPageView(location.pathname);
  }, [location.key, location.pathname, location.search, location.hash]);
}
